/* eslint-disable complexity */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { fadeIn } from '@animations/fade-in';
import { ConnectionStatusService } from '@shared/services/connection-status.service';
import { DateTime } from 'luxon';
import { distinctUntilChanged, map, Observable, timer } from 'rxjs';

@Component({
  selector: 'app-data-status',
  templateUrl: './data-status.component.html',
  styleUrls: ['./data-status.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeIn],
})
export class DataStatusComponent implements OnInit {
  @Input() timestamp?: DateTime;
  @Input() isLoading?: boolean;
  @Output() refresh = new EventEmitter<void>();
  connectionStatus$ = this.connectionStatusService.connectionStatus$;
  dataAgeMsg$?: Observable<string>;

  constructor(private connectionStatusService: ConnectionStatusService) {}

  ngOnInit(): void {
    this.dataAgeMsg$ = timer(0, 1000).pipe(
      map(() => {
        if (this.timestamp) {
          // All time stamps are set to UTC time zone to keep them from changing when the device
          // changes time zone. Now needs to be UTC as well to keep the dates from being different
          // late in the day.
          const now = DateTime.now().toUTC();
          const dataAge = this.timestamp.diff(now, [
            'days',
            'hours',
            'minutes',
          ]);
          const minutes = Math.trunc(Math.abs(dataAge.minutes));
          const hours = Math.trunc(Math.abs(dataAge.hours));
          const days = Math.trunc(Math.abs(dataAge.days));

          if (!dataAge.isValid) {
            return '';
          }

          if (days === 0 && hours === 0 && minutes === 0) {
            return 'Updated just now';
          } else if (days > 0) {
            return `Updated ${days} day${days < 2 ? '' : 's'} ago`;
          } else if (hours > 0) {
            return `Updated ${hours} hour${hours < 2 ? '' : 's'} ago`;
          } else {
            return `Updated ${minutes} min ago`;
          }
        }
        return '';
      }),
      distinctUntilChanged(),
    );
  }
}
